import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import Reveal from "@/components/site/Reveal";
import { Icon } from "@/components/site/Icon";
import { STATS } from "@/data/content";

const Impact = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      id="impact"
      data-testid="impact-section"
      ref={ref}
      className="relative bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1300px] px-6 md:px-10">
        <Reveal className="mb-14 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <p className="mb-4 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.25em] text-gold-primary">
              <span className="h-px w-8 bg-gold-primary" /> Proven Track Record
            </p>
            <h2 className="font-display text-4xl font-extralight leading-[1.05] tracking-tightest text-green-primary md:text-6xl">
              Recruitment metrics built on <span className="italic text-gradient-gold">trust & results.</span>
            </h2>
          </div>
          <p className="max-w-sm text-base leading-relaxed text-green-primary md:text-lg font-medium">
            Five years of quantifiable talent acquisition milestones across executive search, permanent staffing, and volume hiring.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal
              key={s.label}
              delay={i * 0.08}
              className="group rounded-3xl border border-gold-soft bg-gold-light p-8 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-gold-primary hover:shadow-luxe"
            >
              <div>
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-green-primary text-gold-primary transition-transform duration-500 group-hover:scale-110 shadow-sm">
                  <Icon name={s.icon} />
                </span>
              </div>

              <p className="mt-6 font-display text-4xl font-light tracking-tight text-green-primary md:text-5xl">
                {inView ? (
                  <CountUp end={s.value} duration={2.4} separator="," />
                ) : (
                  s.value.toLocaleString()
                )}
                <span className="text-gold-primary font-normal">{s.suffix}</span>
              </p>

              <p className="mt-2 text-xs font-bold uppercase tracking-[0.14em] text-green-primary">
                {s.label}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
